import React, { useCallback } from 'react';
import styles from './DipGallery.module.css';
import downTrendIcon from '../../assets/image/dashboard-images/down-arrow 1.png';
import graph from '../../assets/image/chart.png';

const DipGalleryCard = ({ data, logoSrc, isSelected, isCompact, onClick }) => {
  const handleClick = useCallback(() => {
    onClick?.();
  }, [onClick]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.();
    }
  }, [onClick]);

  // Compact card for the horizontal strip
  if (isCompact) {
    return (
      <div
        className={`${styles.compactCard} ${isSelected ? styles.selected : ''}`}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        role="button"
        aria-label={`View ${data.stock} chart`}
        aria-pressed={isSelected}
      >
        <div className={styles.compactCardContent}>
          <img 
            src={logoSrc} 
            alt={`${data.stock} logo`} 
            className={styles.compactLogo}
          />
          <div className={styles.compactInfo}>
            <span className={styles.compactStock}>{data.stock}</span>
            <span className={styles.compactDip}>
              <img src={downTrendIcon} alt="" className={styles.compactTrendIcon} />
              {data.threshold}%
            </span>
          </div>
        </div>
        {isSelected && <div className={styles.selectedIndicator} />}
      </div>
    );
  }

  // Full card for grid view
  return (
    <div
      className={styles.fullCard}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
      aria-label={`View ${data.stock} chart`}
    >
      <div className={styles.fullCardTop}>
        <div className={styles.logoWrapper}>
          <img src={logoSrc} alt={`${data.stock} logo`} />
        </div>
        <h4 className={styles.stockTitle}>{data.stock}</h4>
        <span className={styles.graphIcon}>
          <img src={graph} alt="View Graph" />
        </span>
      </div>

      <div className={styles.cardDivider} />

      <div className={styles.fullCardBody}>
        <div className={styles.cardMetric}>
          <h4 className={styles.dipPercentage}>
            <img src={downTrendIcon} alt="" />
            {data.threshold}%
          </h4>
          <h5 className={styles.daysLabel}>In {data.no_of_days_from_peak} Days</h5>
        </div>
        <div className={styles.cardMetric}>
          <p className={styles.ltpValue}>
            <span className={styles.ltpLabel}>LTP:</span>
            {data.cmp}
          </p>
        </div>
      </div>

      <div className={styles.cardDivider} />

      <div className={styles.fullCardFooter}>
        <span className={styles.viewChartHint}>Click to view chart</span>
      </div>
    </div>
  );
};

export default DipGalleryCard;

